import { type DateValue } from "@internationalized/date";

export const calendarDateToUTC = (value: DateValue): Date =>
  new Date(Date.UTC(value.year, value.month - 1, value.day));
